import { FormVmValueFormatterType } from '../infrastructure/form-viewmodel-controller';

const trimSpaces: FormVmValueFormatterType<string> = val => String.prototype.replace.call(val || '', /\s/g, '');
const trimSpacesLeft: FormVmValueFormatterType<string> = val => String.prototype.trimLeft.call(val || '');

export {
    trimSpaces,
    trimSpacesLeft,
};
